module.exports = __webpack_public_path__ + "static/og-6f821eff974f023f71b9a9048ade6f97.png";